// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3jq9t","label":"CategoryService_label__f8Gx3","location":"CategoryService_location__2Axci"};